import Container from '@/components/base/Container';
import Section from '@/components/base/Section';
import SectionHeading from '@/components/base/SectionHeading';
import ButtonLink from '@/components/base/ButtonLink';
import ServiceCard from '@/components/base/ServiceCard';
import CommunityCard from '@/components/base/CommunityCard';
import NumberedSteps from '@/components/base/NumberedSteps';
import { coreServices, communityTypes, approachSteps } from '@/mocks/site';
import HeroStage from './components/HeroStage';
import AccordionGallery from './components/AccordionGallery';
import ClosingEditorial from './components/ClosingEditorial';

export default function Home() {
  return (
    <>
      <HeroStage />

      <Section labelledBy="services-heading">
        <Container>
          <SectionHeading
            id="services-heading"
            eyebrow="Core services"
            title="Four areas we look after every day."
            lead="Each community has its own priorities, but the essentials stay the same: well-run operations, sound buildings, cared-for grounds and responsive support."
            aside={<ButtonLink to="/services" variant="text">All services</ButtonLink>}
          />
          <div className="grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-2">
            {coreServices.map((s, i) => (
              <ServiceCard key={s.id} index={i + 1} title={s.title} summary={s.summary} image={s.image} />
            ))}
          </div>
        </Container>
      </Section>

      <AccordionGallery />

      <Section labelledBy="communities-heading">
        <Container>
          <SectionHeading
            id="communities-heading"
            eyebrow="Communities"
            title="Management shaped around how a community is owned and lived in."
            aside={<ButtonLink to="/communities" variant="text">Community types</ButtonLink>}
          />
          <div className="grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-3">
            {communityTypes.map((c) => (
              <CommunityCard key={c.id} title={c.title} summary={c.summary} image={c.image} linkTo="/communities" />
            ))}
          </div>
        </Container>
      </Section>

      <Section labelledBy="approach-heading">
        <Container>
          <SectionHeading
            id="approach-heading"
            eyebrow="Our approach"
            title="A steady way of working, year after year."
            lead="Nothing proprietary, just the habits that keep a community in good shape: understand it, plan for it, look after it, and keep getting better at it."
          />
          <NumberedSteps steps={approachSteps} />
        </Container>
      </Section>

      <ClosingEditorial />
    </>
  );
}